import axios from 'axios'
import ElasticSearch from './ElasticSearch'

const resource = 'client_characteristics'

export default class ClientCharacteristicsES extends ElasticSearch {
  static get indexes () {
    return this.getEnvironmentIndexForResource(resource)
  }

  static async getClientCharacteristics () {
    await this.ensureIndex(resource)

    const searchParams = {
      size: 100
    }
    return axios.post(`/${this.endpoint}/${this.indexes}/_search`, searchParams)
  }
}
